import { useEffect } from 'react'
import { GunIcon } from './gun-icon'
import { BoltIcon } from './bolt-icon'

export const GunControls = ({
  gunMode,
  setGunMode,
  gunDefaultEvent,
  setGunDefaultEvent,
  gunAutoSubmit,
  setGunAutoSubmit,
  canAutoSubmitNow
}) => {
  useEffect(() => {
    if (!gunMode && gunAutoSubmit) setGunAutoSubmit(false)
  }, [gunMode]) // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (!canAutoSubmitNow && gunAutoSubmit && (gunDefaultEvent === 'entry' || gunDefaultEvent === 'exit')) {
      setGunAutoSubmit(false)
      if (gunDefaultEvent !== 'query') setGunDefaultEvent('query')
    }
  }, [canAutoSubmitNow]) // eslint-disable-line react-hooks/exhaustive-deps

  const cycleAutoState = () => {
    if (!gunMode) return
    const order = canAutoSubmitNow ? ['off', 'query', 'entry', 'exit'] : ['off', 'query']
    const current = gunAutoSubmit ? gunDefaultEvent : 'off'
    const next = order[(order.indexOf(current) + 1) % order.length]
    if (next === 'off') {
      setGunAutoSubmit(false)
    } else {
      setGunDefaultEvent(next)
      setGunAutoSubmit(true)
    }
  }

  const rawState = gunAutoSubmit && gunMode ? gunDefaultEvent : 'off'
  const autoState = !canAutoSubmitNow && (rawState === 'entry' || rawState === 'exit') ? 'off' : rawState

  const autoTooltip = !gunMode
    ? 'Activa Modo pistola para auto-enviar'
    : autoState === 'off'
      ? 'Auto-enviar al leer: desactivado'
      : `Auto-enviar al leer: ${autoState === 'query' ? 'consulta' : autoState === 'entry' ? 'entrada' : 'salida'}`

  const actionColors = {
    off: { btn: 'bg-white text-gray-400 border-gray-200', icon: 'text-gray-300', caption: 'text-gray-500' },
    query: { btn: 'bg-gray-200 text-gray-700 border-gray-300 shadow-inner', icon: 'text-gray-700', caption: 'text-gray-700' },
    entry: { btn: 'bg-green-500 text-white border-green-600 shadow-inner', icon: 'text-white', caption: 'text-green-600' },
    exit: { btn: 'bg-blue-500 text-white border-blue-600 shadow-inner', icon: 'text-white', caption: 'text-blue-600' }
  }

  const autoClasses = actionColors[autoState] || actionColors.off

  return (
    <div className="border border-gray-200 rounded p-4">
      <div className="grid grid-cols-2 gap-3">
        <div className="relative group">
          <button
            type="button"
            onClick={(e) => {
              setGunMode(!gunMode)
              e.currentTarget.blur()
            }}
            aria-pressed={gunMode}
            aria-label={gunMode ? 'Modo pistola activo' : 'Modo pistola'}
            className={[
              'inline-flex items-center justify-center h-14 w-full rounded-xl border transition select-none',
              gunMode
                ? 'bg-red-600 text-white border-red-700 shadow-inner'
                : 'bg-white text-gray-700 border-gray-300 hover:bg-gray-50'
            ].join(' ')}
          >
            <GunIcon className="h-7 w-7" />
          </button>
          <span
            className={[
              'pointer-events-none absolute left-1/2 -translate-x-1/2 mt-2 hidden whitespace-nowrap rounded-md px-2 py-1 text-xs text-white shadow group-hover:block',
              gunMode ? 'bg-red-700' : 'bg-gray-900'
            ].join(' ')}
            role="tooltip"
          >
            {gunMode ? 'Modo pistola activo' : 'Modo pistola'}
          </span>
        </div>

        <div className="relative group">
          <button
            type="button"
            onClick={(e) => {
              cycleAutoState()
              e.currentTarget.blur()
            }}
            aria-pressed={gunAutoSubmit && gunMode}
            aria-disabled={!gunMode}
            disabled={!gunMode}
            aria-label={autoTooltip}
            className={[
              'inline-flex items-center justify-center h-14 w-full rounded-xl border transition select-none',
              gunMode ? autoClasses.btn : actionColors.off.btn,
              !gunMode ? 'cursor-not-allowed' : ''
            ].join(' ')}
          >
            <BoltIcon className={['h-7 w-7', gunMode ? autoClasses.icon : actionColors.off.icon].join(' ')} />
          </button>
          <span
            className="pointer-events-none absolute left-1/2 -translate-x-1/2 mt-2 hidden whitespace-nowrap rounded-md bg-gray-900 px-2 py-1 text-xs text-white shadow group-hover:block"
            role="tooltip"
          >
            {autoTooltip}
          </span>
        </div>

        {gunMode && (
          <div className={`col-span-2 text-center text-xs mt-1 ${autoClasses.caption}`}>
            {autoState === 'off'
              ? 'Auto-envío desactivado'
              : `Auto-envío para ${autoState === 'query' ? 'consulta' : autoState === 'entry' ? 'entrada' : 'salida'}`}
          </div>
        )}
      </div>
    </div>
  )
}